<template>
    <section class="relative py-10 w-full text-white xl:py-20">
        <!-- Background angle shape -->
        <div class="absolute inset-0">

            <nuxt-img src="/assets/images/final-call-new.jpg" width="1920" height="1458"
                class="hidden object-cover w-full h-full lg:block" format="webp" loading="lazy"
                sizes="xs:330px sm:440px md:760px lg:1024px xl:1200px 2xl:1920px" />

            <div class="absolute inset-0 w-full h-full bg-black/30 lg:hidden">
            </div>
            <nuxt-img src="/assets/images/last-order-mobile-new-12.jpg" width="474" height="774"
                class="block object-cover w-full h-full lg:hidden" format="webp" alt="Mindflow Final Offer Background"
                loading="lazy" sizes="xs:330px sm:440px md:760px lg:1024px xl:1200px 2xl:1920px" />
        </div>

        <div class="grid relative z-10 gap-12 px-4 mx-auto max-w-5xl">
            <!-- LEFT CONTENT -->
            <div class="">
                <div class="lg:max-w-lg">
                    <h3
                        class="mb-2 text-2xl font-extrabold text-center text-lifeboost-green-400 lg:text-left font-ww-bold xl:text-42 md:text-3xl">
                        FINAL CALL
                    </h3>
                    <h4
                        class="mb-2 text-2xl font-extrabold text-center text-white lg:text-left font-ww-bold xl:text-42 md:text-3xl">
                        Momentum Loves Speed
                    </h4>

                    <p
                        class="mt-3 mb-6 text-base leading-relaxed text-white lg:mt-6 xl:mt-10 xl:mb-8 xl:text-xl md:text-lg font-ww-regular">
                        Your brain thrives on consistency. Skip the re-order scramble, sidestep retail pricing,
                        and glide through the next six months with uninterrupted MindFlow.
                    </p>

                    <!-- Compliance box -->
                    <div class="px-4 pt-4 pb-8 lg:px-10 xl:pt-6 xl:pb-12 lg:bg-white/10 bg-gray-500/50">
                        <h4 class="mb-5 text-sm font-bold md:text-base xl:text-lg font-ww-bold">Compliance &
                            Transparency
                        </h4>

                        <ul
                            class="text-sm !leading-6 text-white md:text-base xl:text-lg font-ww-regular space-y-0.5 ml-2">
                            <li>• These statements have not been evaluated by the Food and Drug Administration.</li>
                            <li>• MindFlow is not intended to diagnose, treat, cure, or prevent any disease.</li>
                            <li>• Savings based on current one-time price of $36/bag plus $9.95 shipping.</li>
                            <li>• Consult your healthcare professional before use if pregnant, nursing, or taking
                                medication.</li>
                            <li>• Testimonials are unpaid, supplied by verified purchasers, and substantively typical.
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="mx-auto mt-8 mb-10 xl:mt-12 max-w-fit lg:mx-0 md:mb-0">
                    <button
                        @click="handleAccept"
                        class="flex gap-x-2 justify-center items-center px-6 py-3 mx-auto w-full text-lg text-white rounded-full lg:mx-0 md:gap-x-4 md-max:text-base md:px-12 md:py-5 btn-red md:text-2xl font-ww-medium">👉
                        YES, Upgrade My Order to 6 More Bags for $127.50<span><svg width="21" height="15"
                                viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg"
                                data-v-inspector="components/section/content/ComparisonPrice.vue:97:25">
                                <path
                                    d="M12.8593 0.338767C12.7655 0.43173 12.6911 0.542331 12.6404 0.66419C12.5896 0.78605 12.5635 0.916755 12.5635 1.04877C12.5635 1.18078 12.5896 1.31148 12.6404 1.43334C12.6911 1.5552 12.7655 1.6658 12.8593 1.75877L17.4593 6.35877L1.05859 6.17123C0.793377 6.17123 0.539023 6.27659 0.351487 6.46412C0.163951 6.65166 0.0585938 6.90601 0.0585938 7.17123C0.0585938 7.43645 0.163951 7.6908 0.351487 7.87834C0.539023 8.06587 0.793377 8.17123 1.05859 8.17123L17.4393 8.35877L12.8593 12.9288C12.673 13.1161 12.5685 13.3696 12.5685 13.6338C12.5685 13.898 12.673 14.1514 12.8593 14.3388C13.0466 14.525 13.3001 14.6296 13.5643 14.6296C13.8284 14.6296 14.0819 14.525 14.2693 14.3388L20.6293 7.97877C20.7149 7.89664 20.783 7.79805 20.8295 7.68892C20.876 7.5798 20.9 7.4624 20.9 7.34377C20.9 7.22514 20.876 7.10773 20.8295 6.99861C20.783 6.88949 20.7149 6.7909 20.6293 6.70877L14.2793 0.338767C14.1863 0.245039 14.0757 0.170645 13.9538 0.119876C13.832 0.0691072 13.7013 0.0429688 13.5693 0.0429688C13.4372 0.0429688 13.3065 0.0691072 13.1847 0.119876C13.0628 0.170645 12.9522 0.245039 12.8593 0.338767Z"
                                    fill="white"></path>
                            </svg></span></button>
                </div>
                <!-- CTA BUTTON -->
            </div>
        </div>
    </section>
</template>

<script setup>
// Inject the handleAccept function from parent upsell modal
const handleAccept = inject('handleAccept', () => {
    console.warn('handleAccept not provided by parent')
})
</script>